// ----------------------------------------------------------------------
import { FONTSTYPO, SPACING } from "../palette";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, import/no-default-export
export default function Accordion(theme) {
    return {
        "MuiAccordion": {
            "styleOverrides": {
                "root": {
                    "&.Mui-expanded": {
                        "&:before": {
                            "opacity": 1
                        },
                        ".MuiAccordionSummary-content": {
                            "margin": 0
                        }
                    },
                    "&:before": {
                        "backgroundColor": theme.palette.grey[900]
                    },
                    ".MuiAccordionSummary-content": {
                        "color": theme.palette.primary.dark,
                        "fontSize": FONTSTYPO.step1,
                        "lineHeight": 1.2,
                        "margin": 0,
                        "paddingBlock": SPACING.spaces
                    },
                    "background": "transparent",
                    "boxShadow": "none"
                }
            },
        },
        "MuiAccordionDetails": {
            "styleOverrides": {
                "root": {
                    "padding": 0,
                    "paddingBlock": SPACING.spaces,
                }
            }
        },
        "MuiAccordionSummary": {
            "styleOverrides": {
                "root": {
                    "&.Mui-expanded": {
                        "background": theme.palette.common.white,
                        "position": "sticky",
                        "top": 0
                    }
                }
            }
        }
    };
}
